// src/components/Layout/Sidebar.js (Corrected)

import React, { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { 
  FiChevronRight, FiChevronDown, FiBox
} from 'react-icons/fi';
import logoSrc from '../../assets/images/full logo.png';


const SidebarWrapper = styled.aside`
  width: ${({ theme }) => theme.sidebarWidth};
  background-color: rgb(32 32 32);
  color: ${({ theme }) => theme.colors.sidebarText};
  height: 100vh;
  position: fixed;
  top: 0;
  left: ${({ isOpen, theme }) => (isOpen ? '0' : `-${theme.sidebarWidth}`)};
  transition: left ${({ theme }) => theme.transitions.medium};
  z-index: 999;
  display: flex;
  flex-direction: column;
  box-shadow: ${({ theme }) => theme.shadows.lg};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    left: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
    width: 85%;
    max-width: 300px;
  }
`;

const SidebarHeader = styled.div`
  height: ${({ theme }) => theme.navbarHeight};
  display: flex;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing.lg};
  border-bottom: 1px solid ${({ theme }) => theme.colors.sidebarBg === theme.colors.surface ? theme.colors.lightBorder : '#374151'};
`;

const LogoLinkSidebar = styled(NavLink)`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const LogoImageSidebar = styled.img`
  height: 30px;
  margin-right: ${({ theme }) => theme.spacing.sm};
`;

const LogoTextSidebar = styled.span`
  font-size: 1.4rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.sidebarTextHover};
  letter-spacing: -0.5px;
`;

const NavList = styled.ul`
  list-style: none;
  padding: ${({ theme }) => theme.spacing.md} 0;
  margin: 0;
  flex-grow: 1;
  overflow-y: auto;

  &::-webkit-scrollbar { width: 5px; }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.sidebarIcon};
    border-radius: ${({ theme }) => theme.borderRadius.small};
  }
  &::-webkit-scrollbar-track { background-color: transparent; }
`;

const NavItem = styled.li`
  margin: ${({ theme }) => theme.spacing.xxs} ${({ theme }) => theme.spacing.sm};
`;

const NavLinkBase = styled.div`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing.sm} ${theme.spacing.md}`};
  color: ${({ theme }) => theme.colors.sidebarText};
  text-decoration: none;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  transition: ${({ theme }) => theme.transitions.short};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: 0.95rem;
  cursor: pointer;

  svg:first-child {
    margin-right: ${({ theme }) => theme.spacing.md};
    font-size: 1.25rem;
    color: ${({ theme }) => theme.colors.sidebarIcon};
    transition: ${({ theme }) => theme.transitions.short};
  }

  .chevron-icon {
    margin-left: auto;
    font-size: 1rem;
    transition: transform 0.2s ease-in-out;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.sidebarActiveBg};
    color: ${({ theme }) => theme.colors.sidebarTextHover};
    svg { color: ${({ theme }) => theme.colors.sidebarIconHover}; }
  }
`;

const StyledNavLink = styled(NavLink)`
  ${NavLinkBase}

  &.active {
    background-color: ${({ theme }) => theme.colors.sidebarActiveBg};
    color: ${({ theme }) => theme.colors.sidebarActiveText};
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 70%;
      width: 4px;
      background-color: ${({ theme }) => theme.colors.sidebarActiveIndicator}; 
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }

    svg:first-child {
      color: ${({ theme }) => theme.colors.sidebarActiveIndicator};
    }
  }
`;

const DropdownHeader = styled(NavLinkBase)``;

const SubNavList = styled.ul`
  list-style: none;
  padding-left: ${({ theme }) => `calc(${theme.spacing.md} + 1.25rem + ${theme.spacing.md})`};
  margin: ${({ theme }) => theme.spacing.xxs} 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  opacity: 0;

  &.open {
    max-height: 500px;
    opacity: 1;
  }
`;

const SubNavItem = styled.li``;

const SubStyledNavLink = styled(NavLink)`
  display: block;
  padding: ${({ theme }) => `${theme.spacing.sm} ${theme.spacing.md}`};
  color: ${({ theme }) => theme.colors.sidebarTextMuted || theme.colors.sidebarText};
  text-decoration: none;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  transition: ${({ theme }) => theme.transitions.short};
  font-size: 0.9rem;
  position: relative;

  &:hover {
    background-color: ${({ theme }) => theme.colors.sidebarActiveBg};
    color: ${({ theme }) => theme.colors.sidebarTextHover};
  }

  &.active {
    color: ${({ theme }) => theme.colors.sidebarActiveIndicator};
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
    &::before {
      content: '•';
      position: absolute;
      left: ${({ theme }) => `calc(${theme.spacing.md} / 2)`};
      top: 50%;
      transform: translateY(-50%);
      font-size: 0.8rem;
    }
  }
`;


const Sidebar = ({ isOpen, toggleSidebar }) => {
  const currentTheme = useTheme();

  const [openDropdown, setOpenDropdown] = useState(null);

  const handleLinkClick = () => {
    if (window.innerWidth <= parseInt(currentTheme.breakpoints.md.replace('px', ''))) {
      toggleSidebar();
    }
  };

  const handleDropdownToggle = (key) => {
    setOpenDropdown(openDropdown === key ? null : key);
  };

  const allMenuItems = [
      { 
        key: "orders Page",
        icon: FiBox,
        label: "OrdersPage",
        subItems: [
          { to: "/dash/Orderspage", label: "orderspage" },
        ]
      },
      { 
        key: "Login Record",
        icon: FiBox,
        label: "Login Record",
        subItems: [
          { to: "/dash/loginrecord", label: "login record" },
        ]
      },
      { 
        key: "Users Page",
        icon: FiBox,
        label: "Users Page",
        subItems: [
          { to: "/dash/userspage", label: "userspage" },
        ]
      },
      { 
        key: "Contact Us",
        icon: FiBox,
        label: "Contact Us",
        subItems: [
          { to: "/dash/contactusrecord", label: "ContactUs" },
        ]
      },
  ];

  const menuItems = allMenuItems;

  return (
    <SidebarWrapper isOpen={isOpen}>
      <SidebarHeader>
        <LogoLinkSidebar to="/" onClick={handleLinkClick}>
          {/* <LogoImageSidebar src={logoSrc} alt="Logo" style={{height:'75px', width:'145px'}}/> */}
          <LogoTextSidebar>N F C</LogoTextSidebar>
        </LogoLinkSidebar>
      </SidebarHeader>
      <NavList>
        {menuItems.map(item => {
          // ===============================================
          // =================== THE FIX ===================
          // ===============================================
          // Assign the icon component to a capitalized variable
          const IconComponent = item.icon;
          // ===============================================

          return (
            <NavItem key={item.key || item.to}>
              {item.subItems ? (
                <>
                  <DropdownHeader onClick={() => handleDropdownToggle(item.key)}>
                    {/* Render the new capitalized variable */}
                    <IconComponent /> 
                    <span>{item.label}</span>
                    {openDropdown === item.key ? 
                      <FiChevronDown className="chevron-icon" /> : 
                      <FiChevronRight className="chevron-icon" />
                    }
                  </DropdownHeader>
                  <SubNavList className={openDropdown === item.key ? 'open' : ''}>
                    {item.subItems.map(subItem => (
                      <SubNavItem key={subItem.to}>
                        <SubStyledNavLink 
                          to={subItem.to} 
                          onClick={handleLinkClick}
                          end={subItem.end}
                        >
                          <span>{subItem.label}</span>
                        </SubStyledNavLink>
                      </SubNavItem>
                    ))}
                  </SubNavList>
                </>
              ) : (
                <StyledNavLink 
                  to={item.to} 
                  onClick={handleLinkClick}
                  end={item.end}
                >
                  {/* Also render the new capitalized variable here */}
                  <IconComponent /> 
                  <span>{item.label}</span>
                </StyledNavLink>
              )}
            </NavItem>
          );
        })}
      </NavList>
    </SidebarWrapper>
  );
};

export default Sidebar;